import React from 'react'
import './ProfileAuthorActionCard.css'
import ShareIcon from "@material-ui/icons/Share"
import ReportIcon from "@material-ui/icons/Report"

function profileAuthorActionCard() {
    return (
        <ul className="profileAuthorActionCard">
            <li><a href="#">Follow</a></li>
            <li><a href="#"><ShareIcon/></a></li>
            <li><a href="#"><ReportIcon/></a></li>
        </ul>
    )
}

export default profileAuthorActionCard
